// NOTE: This file should be used for exports only
import { withSuspense } from 'components/Decorators';
import { lazy } from 'react';
import Fallback from './UseCases.fallback';

export type { UseCasesProps } from './types';

export { default as testIds } from './testIds';

export default withSuspense(
  lazy(() => import('./UseCases')),
  Fallback,
);
